module.exports = __webpack_public_path__ + "img/case6-华东医药.529fcd27.png";